import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useCountry } from '../../components/CountrySelector';
import { useOrderSummary, GET_ORDER_SUMMARY_QUERY } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';
import { UPDATE_ORDER_SHIPPING_ADDRESS_MUTATION } from './useUpdateOrderShippingAddress.rest';

export const useUpdateOrderShippingAddress = (orderNumber: string) => {
  const {
    country: { alpha2Code, alpha3Code }
  } = useCountry();

  const { orderSummary } = useOrderSummary(orderNumber);

  const [mutate, { loading, error }] = useMutation(UPDATE_ORDER_SHIPPING_ADDRESS_MUTATION, {
    refetchQueries: [
      {
        query: GET_ORDER_SUMMARY_QUERY,
        variables: {
          countryCode: alpha2Code,
          orderNumber: orderNumber
        }
      }
    ]
  });

  const updateOrderShippingAddress = useCallback(
    (selectedAddressId: string) => {
      if (!orderSummary)
        return Promise.reject('updateOrderShippingAddress: orderSummary is not fetched');

      return mutate({
        variables: {
          orderId: orderSummary.id,
          input: {
            data: {
              action_type: UpdateOrderAction.ChangeAddress,
              id: orderSummary.id,
              type: 'orders',
              attributes: {
                country_code: alpha3Code,
                order_state: OrderState.Default,
                selected_address_id: selectedAddressId
              }
            }
          }
        }
      });
    },
    [alpha3Code, mutate, orderSummary]
  );

  return { updateOrderShippingAddress, loading, error };
};
